import React from 'react';
import styles from './Header.module.css';
// Импортируйте остальные хук/утилиты, если нужны
// import { useGetSelfQuery } from '../../../../redux/services/TraderApi';

type HeaderProps = {
  // page?: 'withdrawal' | 'orders'; // или ваши пропсы
};

export const Header: React.FC<HeaderProps> = (/* { page = 'orders' } */) => {
  // const { data: trader, isLoading } = useGetSelfQuery(undefined, { pollingInterval: 5000 });

  /*
  if (isLoading) {
    return <Loading />;
  }

  return (
    <header className={styles.header}>
      <h1 className={styles.title}>
        {page === 'orders' ? 'Заказы' : 'Вывод средств'}
      </h1>
      <div className={styles.info}>
        <span>Баланс:</span>
        <strong>{trader?.balance}</strong>
      </div>
      <nav>
        <Link to="/orders" className={styles.link}>
          Заказы
        </Link>
        <Link to="/withdrawal" className={styles.link}>
          Вывод
        </Link>
      </nav>
    </header>
  );
  */

  // Пока что заглушка, чтобы сборка прошла
  return <></>;
};
